<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa ri-question-answer-fill" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 pr-0">
            <b-button class="right-align-sm" v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" variant="primary" @click="socialmediareportAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row px-3 pb-3" v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'">
          <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <div class="card text-white bg-primary mt-3">
              <div class="card-body">
                <h5 class="card-title text-white" style="text-align:center; justify-content: center;">
                  <div>Share<br>
                    <span v-if="Share">{{Share}}</span>
                    <span v-else>0</span>
                  </div>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <div class="card mt-3 text-white" style="background-color:var(--cyan)">
              <div class="card-body">
                <h5 class="card-title text-white" style="text-align:center; justify-content: center;">
                  <div>Comments<br>
                    <span v-if="Comments">{{Comments}}</span>
                    <span v-else>0</span>
                  </div>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <div class="card mt-3 text-white bg-danger">
              <div class="card-body">
                <h5 class="card-title text-white" style="text-align:center; justify-content: center;">
                  <div>Reach<br>
                    <span v-if="Reach">{{Reach}}</span>
                    <span v-else>0</span>
                  </div>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <div class="card mt-3 text-white bg-warning">
              <div class="card-body">
                <h5 class="card-title text-white" style="text-align:center; justify-content: center;">
                  <div>Likes<br>
                    <span v-if="Likes">{{Likes}}</span>
                    <span v-else>0</span>
                  </div>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <div class="card mt-3 text-white" style="background-color:var(--indigo)">
              <div class="card-body">
                <h5 class="card-title text-white" style="text-align:center; justify-content: center;">
                  <div>Impression<br>
                    <span v-if="Impression">{{Impression}}</span>
                    <span v-else>0</span>
                  </div>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <div class="card mt-3 text-white" style="background-color:var(--info)">
              <div class="card-body">
                <h5 class="card-title text-white" style="text-align:center; justify-content: center;">
                  <div>Saves<br>
                    <span v-if="Saves">{{Saves}}</span>
                    <span v-else>0</span>
                  </div>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-3">
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"
                ></b-form-input>
              </b-col>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                <select v-if="(userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111')" v-model="whereFilter.moduleType" class="form-control" @change="setFilters" required>
                  <option value="" disabled>Choose Org Type</option>
                  <option value="All">All</option>
                  <option v-for="(orgType, index) of cvUserTypesOptions" :key="(index+1)" :value="orgType.key">
                    {{orgType.value}}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-2" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11116'">
                <select v-model="whereFilter.deliverable_type" class="form-control" @change="setFilters" title="Deliverable Type">
                  <option disabled value="">Deliverable Type</option>
                  <option value="All">All</option>
                  <option v-for="(DeliverableType, index) of DeliverableType" :key="(index+1)" :value="index" >
                    {{ DeliverableType }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                <select v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11116'" class="form-control" v-model="whereFilter.platform" @change="setFilters">
                  <option disabled value="">Choose Platform</option>
                  <option value="All">All</option>
                  <option v-for="(Social_platform, index) of SociaMediaPlatforms" :key="(index+1)" :value="index">{{ Social_platform }}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                <div class="dateRange">
                  <date-range-picker ref="picker" class="w-100"  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getSocialMediaReportDateWise()" ></date-range-picker>
                </div>
              </div>
            </b-row>
          </b-col>
          <b-col class="mb-2 col-12 col-lg-2 pr-0 mb-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
            <!-- Backend csv download -->
            <i class="fa-solid fa-file-csv Download_button" v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'"  title="Download CSV" @click="backendCsvDownload"></i>
            <!-- Backend csv download -->
          </b-col>
        </div>
        <div class="iq-card row p-3" :key="currentBatchNo">
          <b-col md="12" v-if="socialmediareportObjList && socialmediareportObjList.length > 0">
            <b-table
              hover
              responsive
              :items="socialmediareportObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentPage"
              :per-page="dataPerPage"
            >
            <template v-slot:cell(topic)="data">
              <span>
                <p class="m-0" v-html="data.item.topic"></p>
                <small v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" v-html="data.item.creative_id" style="word-wrap: break-word" class="mb-0"></small>
                <i v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" class="fa-solid fa-copy pointer pl-2" @click="doCopy(data.item.creative_id)"></i>
              </span>
              <br>
              <b-button variant="iq-bg-success mr-1 mb-1" @click="showSocialMedia(data.item.url)" size="sm" v-if="!data.item.editable && data.item.url && (userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111')" >
                <i class="fa fa-link m-0 actionIcon font-size-20"></i>
              </b-button>
              <b-button variant="iq-bg-success mr-1 mb-1" size="sm" @click="socialmediareportEdit(data.item)" v-if="!data.item.editable && (userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111')" >
                <i class="ri-ball-pen-fill m-0 actionIcon font-size-20"></i>
              </b-button>
              <b-button variant="iq-bg-danger" @click="showSocialMediaReportDeleteDialog(data.item)" v-if="!data.item.editable && (userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111')" size="sm">
                <i class="ri-delete-bin-line m-0 actionIcon font-size-20"></i>
              </b-button>
            </template>
            <template v-slot:cell(module_name)="data">
              <p class="m-0" v-html="data.item.module_name"></p>
              <small v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" v-html="data.item.module_id" style="word-wrap: break-word" class="mb-0"></small>
              <i v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" class="fa-solid fa-copy pointer pl-2" @click="doCopy(data.item.module_id)"></i><br>
              <b-badge v-if="data.item.type === 'UNIV'" class="pointer" variant="mr-1 mb-1" size="sm" style="background-color: #FF9900 !important; color: #fff;">
                  University&nbsp;
                </b-badge>
                <b-badge v-if="data.item.type === 'SCH'" class="pointer" variant="mr-1 mb-1" size="sm" style="background-color: #DC3912 !important; color: #fff">
                  School
                </b-badge>
                <b-badge v-if="data.item.type === 'ORG'" class="pointer" variant="mr-1 mb-1" size="sm" style="background-color: #3366CC !important; color: #fff">
                  organisation
                </b-badge>
            </template>
            <template v-slot:cell(post_thumbnail)="data">
              <div class="text-wrap">
                <b-button variant="mb-1" title="View Submited Application" size="sm">
                  <img src="../../../assets_gide/img/logo/gide_logo.png" style="width:24px"/>
                </b-button>
              </div>
            </template>
            <template v-slot:cell(smr_img)="data">
              <img :src="data.item.smr_img" style="height:100px" class="fourLineOnly"/>
            </template>
            <template v-slot:cell(created_on)="data">
              {{getFormattedDateTime(data.item.created_on)}}
            </template>
            </b-table>
          </b-col>
          <b-col md="12" v-else>
            No data found
          </b-col>
          <b-col sm="7" md="8" class="my-1">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelSocialMediaReportAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xl"
    >
      <SocialMediaReportAdd :propOpenedInModal="true" @emitCloseSocialMediaReportAddModal="closeSocialMediaReportAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeSocialMediaReportAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelSocialMediaReportEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xl"
    >
      <SocialMediaReportEdit :propOpenedInModal="true" :propSocialMediaReportObj="socialmediareportEditObj" @emitCloseSocialMediaReportEditModal="closeSocialMediaReportEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeSocialMediaReportEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelSocialMediaReportDelete"
      scrollable
      title="Delete"
      ok-title="Delete"
      cancel-title="Cancel"
      size="xl"
      >
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelSocialMediaReportDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="socialmediareportDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import SociaMediaPlatforms from "../../../FackApi/json/SocialMediaPlatform.json"
import { SocialMediaReports } from "../../../FackApi/api/socialmediareport.js"
import SocialMediaReportAdd from "./SocialMediaReportAdd"
import SocialMediaReportEdit from "./SocialMediaReportEdit"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import DeliverableType from "../../../FackApi/json/DeliverableType.json"
import Utility from "../../../Utils/utility.js"

export default {
  name: "SocialMediaReportList",
  components: {
    SocialMediaReportAdd,
    SocialMediaReportEdit
  },
  data () {
    return {
      cvCardTitle: "Social Media Report",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Social Media Report",
      cvAddModalHeader: "Add Social Media Report",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Social Media Report List Response",
      showModelSocialMediaReportAdd: false,
      showModelSocialMediaReportEdit: false,
      showModelSocialMediaReportDelete: false,
      sortBy: "name",
      sortDesc: false,
      socialmediacountreporList: [],
      DeliverableType: DeliverableType,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Topic", key: "topic", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Organization name", key: "module_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Platform", key: "platform", class: "text-left align-text-top", sortable: true },
        { label: "Deliverable type", key: "deliverable_type", class: "text-left align-text-top w-100px", sortable: true },
        { label: "Reach", key: "reach", class: "text-left align-text-top w-100px", sortable: true },
        { label: "Impression", key: "impression", class: "text-left align-text-top w-100px", sortable: true },
        { label: "Likes", key: "likes", class: "text-left align-text-top w-100px", sortable: true },
        { label: "Saves", key: "saves", class: "text-left align-text-top w-100px", sortable: true },
        { label: "Shares", key: "shares", class: "text-left align-text-top w-100px", sortable: true },
        { label: "image", key: "smr_img", class: "text-left w-100px", sortable: true },
        { label: "Comments", key: "comments", class: "text-left align-text-top w-100px", sortable: true }
      ],
      socialmediareportObjList: null,
      socialmediareportEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      dataPerPage: 10,
      delObj: null,
      univFiltersList: [],
      Share: null,
      Comments: null,
      Impression: null,
      Reach: null,
      Likes: null,
      Saves: null,
      socialMediaFiltersList: [],
      showLoadMoreBtn: true,
      SociaMediaPlatforms: SociaMediaPlatforms,
      doCopy: Utility.doCopy,
      whereFilter: {
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 365)), // From Last Year
          endDate: new Date(new Date().setDate(new Date().getDate() + 1))
        },
        platform: "All",
        moduleType: "All",
        deliverable_type: ""
      },
      cvUserTypesOptions: [
        { key: "UNIV", value: "University" },
        { key: "ORG", value: "Organization" },
        { key: "SCH", value: "School" }
      ]
    }
  },
  computed: {
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    },
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role.
    if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118" || this.userData.org_id == this.$route.query.org_id)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.cvOrgId = this.$route.query.org_id
    await this.getDateFilter()
    this.socialmediareportList()
  },
  methods: {
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentPage = this.currentPage + 1
      this.socialmediareportList(true, false)
    },
    /**
     * Calling Function as per whereFilter
    */
    async getSocialMediaReportDateWise () {
      await this.socialmediacountreportList()
      await this.setDateFilter()
      this.socialmediareportList()
    },
    /**
     * getFormattedDateTime
     */
    getFormattedDateTime (datetime) {
      try {
        return moment(datetime).format("DD-MM-YYYY hh:mm:ss")
      }
      catch (err) {
        console.log("Exception occurred at getFormattedDateTime() and Exception:", err.message)
      }
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
    */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter = storeDate
      }
    },
    /**
     * Setting Date Range in the LS
    */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * socialmediareportList
     */
    async socialmediareportList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        if (this.$route.query.org_id) {
          this.whereFilter.module_id = this.$route.query.org_id
        }
        this.whereFilter.downloadCsv = downloadCsv
        this.whereFilter.currentPage = this.currentPage
        this.whereFilter.dataPerPage = this.dataPerPage
        let socialmediareportListResp = await SocialMediaReports.socialmediareportList(this, this.whereFilter)
        if (socialmediareportListResp.resp_status) {
          if (downloadCsv) {
            window.open(socialmediareportListResp.resp_csv_file_url)
            return
          }
          if (!loadViaLoadMore) {
            this.socialmediareportObjList = [ ...socialmediareportListResp.resp_data.data ]
          }
          else {
            this.socialmediareportObjList = [ ...this.socialmediareportObjList, ...socialmediareportListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true
          this.totalRows = this.socialmediareportObjList.length
        }
        else {
          this.toastMsg = socialmediareportListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at socialmediareportList() and Exception:", err.message)
      }
    },
    /**
     * socialmediareportAdd
     */
    socialmediareportAdd () {
      this.showModelSocialMediaReportAdd = true
    },
    /**
     * socialmediareportEdit
     */
    socialmediareportEdit (item) {
      this.socialmediareportEditObj = item
      this.showModelSocialMediaReportEdit = true
    },
    /**
     * showSocialMediaReportDeleteDialog
     */
    showSocialMediaReportDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelSocialMediaReportDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showSocialMediaReportDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * socialmediareportDelete
     */
    async socialmediareportDelete () {
      try {
        let socialmediareportDelResp = await SocialMediaReports.socialmediareportDelete(this, this.delObj.module_id)
        await ApiResponse.responseMessageDisplay(this, socialmediareportDelResp)

        if (socialmediareportDelResp && !socialmediareportDelResp) {
          this.showModelSocialMediaReportDelete = false
          return false
        }

        let index = this.socialmediareportObjList.indexOf(this.delObj)
        this.socialmediareportObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelSocialMediaReportDelete = false
      }
      catch (err) {
        console.error("Exception occurred at socialmediareportDelete() and Exception:", err.message)
      }
    },
    /**
     * closeSocialMediaReportAddModal
     */
    closeSocialMediaReportAddModal () {
      try {
        this.showModelSocialMediaReportAdd = false
        this.socialmediareportList()
      }
      catch (err) {
        console.error("Exception occurred at closesocialmediareportAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeSocialMediaReportEditModal
     */
    closeSocialMediaReportEditModal () {
      try {
        this.socialmediareportList()
        this.showModelSocialMediaReportEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeSocialMediaReportEditModal() and Exception:", err.message)
      }
    },
    /**
     * backendCsvDownload
    */
    async backendCsvDownload () {
      this.socialmediareportList(false, true)
    },
    /**
     * setFilters
    */
    async setFilters () {
      await this.socialmediareportList()
      await this.socialmediacountreportList()
    },
    /**
     * showSocialMedia
    */
    showSocialMedia (url) {
      window.open(url, "_blank")
    },
    /**
     * socialmediacountreportList
    */
    async socialmediacountreportList () {
      try {
        if (this.cvOrgId) {
          this.whereFilter.module_id = this.cvOrgId
        }

        let socialmediareportListResp = await SocialMediaReports.socialmediacountreportList(this, this.whereFilter)
        if (socialmediareportListResp.resp_status) {
          this.socialmediacountreporList = socialmediareportListResp.resp_data.data
          this.Share = socialmediareportListResp.resp_data.data[0].Shares
          this.Comments = socialmediareportListResp.resp_data.data[0].Comments
          this.Impression = socialmediareportListResp.resp_data.data[0].Impression
          this.Reach = socialmediareportListResp.resp_data.data[0].Reach
          this.Likes = socialmediareportListResp.resp_data.data[0].Likes
          this.Saves = socialmediareportListResp.resp_data.data[0].Saves
          this.totalRows = socialmediareportListResp.resp_data.count
        }
        else {
          this.toastMsg = socialmediareportListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at socialmediareportList() and Exception:", err.message)
      }
    }
  }
}
</script>
<style>
.boxs, .multiCardboxs{
  background-color: #e5252c;
}
</style>
